<template>
    <div>
        <video ref="videoPlayer" style="width:100%; height:607.5px;" class="video-js vjs-big-play-button vjs-big-play-centered"
            controlsdisabled
            muted
            autoplay
            preload="auto">
        </video>
    </div>
</template>

<script>
import videojs from 'video.js';
import videoPlayer from 'videojs-playlist';

export default {
    name: "VideoPlayer",
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            player: null,
            playList: {},
            currentIndex: 0,
            lastIndex: 0,
        }
    },
    mounted() {
        this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {})
        
        this.player.playlist();
        this.player.playlist.autoadvance(0);
        this.player.playlist.repeat(true);
        var self = this;
        this.player.on('ended',function(){
            self.get_currentIndex();
        });
    },
    methods:{
        get_currentIndex(){
            this.currentIndex = this.player.playlist.currentIndex();
            if(this.currentIndex == this.lastIndex && this.lastIndex == 0){
                this.player.play();
            }            
        },
        set_player(){
            // 플레이어에 플레이리스트 변경
            this.player.playlist(this.playList);
            
            this.lastIndex = this.player.playlist.lastIndex();
            this.player.playlist.shuffle();
            this.player.playlist.first();
        }
    },
    computed: {
        get_playList(){
            return this.$store.getters.get_playList;
        },
        get_userPlayList(){
            return this.$store.getters.get_userPlayList;
        }
    },
    watch:{        
        get_playList(){
            this.playList =  this.$store.getters.get_playList;
            this.set_player();
        },
        get_userPlayList(){
            this.playList =  this.$store.getters.get_userPlayList;            
            this.set_player();
        }
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/components/videoPlayer.vue